<div class="p-24">
    <div class="row">
        <div class="col-lg-12 d-flex justify-content-between align-items-center">
            <h3 *ngIf="isEdit">{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'LABEL.GENERIC_CONTENT' | translate }}</h3>
            <h3 *ngIf="!isEdit">{{ 'LABEL.ADD_LABEL' | translate }} {{ 'LABEL.GENERIC_CONTENT' | translate }}</h3>
            <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
                <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
            </button>
        </div>
    </div>

    <form [formGroup]="genericContentForm">
        <div class="row m-t-20">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.GENERIC_CONTENT' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.GENERIC_CONTENT' | translate }}" formControlName="name">
                    <mat-error *ngIf="genericContentForm.get('name')?.hasError('required') && 
                    (genericContentForm.get('name')?.dirty || genericContentForm.get('name')?.touched)">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="genericContentForm.get('name')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM50' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </form>

    <div class="row">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button class="m-r-5" (click)="onCloseDialog()">{{ 'BUTTON.BTN_CLOSE' | translate
                }}</button>

            <button mat-flat-button color="primary" class=" m-l-4" (click)="onUpdateGenericContent()" *ngIf="isEdit"
                [disabled]="genericContentForm.invalid">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>

            <button mat-flat-button color="primary" class=" m-l-4" (click)="onSaveGenericContent()" *ngIf="!isEdit"
                [disabled]="genericContentForm.invalid">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>
        </div>
    </div>
</div>